function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default getDisplayName;


// WEBPACK FOOTER //
// ./client/utils/getDisplayName.js